import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

// Helper function to get the first value from a value or array.
// This is because the query params can be either a single value
// or an array of values.
function firstValue<T>(value: T | T[]): T {
    return Array.isArray(value) ? value[0] : value;
}

export function queryRef(paramName: string, defaultValue: string) {
    const router = useRouter();
    const route = useRoute();

    const paramRef = ref(firstValue(route.query[paramName]) ?? defaultValue);

    watch(paramRef, (newValue) => {
        router.push({
            query: {
                ...route.query,
                [paramName]: newValue !== defaultValue ? newValue : undefined,
            },
        });
    });

    watch(
        () => route.query[paramName],
        (newValue) => {
            paramRef.value = firstValue(newValue) ?? defaultValue;
        },
    );

    return paramRef;
}
